import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

interface HeaderProps {
  /** When true, header styles assume it sits over the dark cinema hero. */
  overCinema?: boolean;
}

const NAV: Array<{ label: string; to: string }> = [
  { label: 'Projects', to: '/projects' },
  { label: 'Journal', to: '/journal' },
  { label: 'Studio', to: '/about' },
  { label: 'Contact', to: '/contact' },
];

export function Header({ overCinema = false }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className="site-header"
      data-over-cinema={overCinema ? 'true' : 'false'}
      data-scrolled={scrolled ? 'true' : 'false'}
    >
      <div className="container site-header__inner">
        <NavLink to="/" className="site-header__brand" aria-label="Brian Ellison Design home">
          <span className="site-header__brand-mark">BED</span>
          <span className="site-header__brand-name">Brian Ellison Design</span>
        </NavLink>
        <nav className="site-header__nav" aria-label="Primary">
          <ul>
            {NAV.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    `site-header__link ${isActive ? 'is-active' : ''}`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
}
